import React from 'react'
import ActionPanelProvider from '../../../components/layout/contextProvider/ActionPanelProvider'
import DetailPanelProvider from '../../../components/layout/contextProvider/DetailPanelProvider'
import DialogProvider from '../../../components/layout/contextProvider/DialogProvider'
import {PAGE, usePageContext} from '../../../components/layout/PageContext'
import SuiviAvancementComponents from './SuiviAvancementComponents'
import AccessChecker from '../../../components/security/AccessChecker'
import {PROFILS} from '../../../utils/constants'
import {getAccessCheckerRole} from '../../../utils/utils'

const SuiviAvancement = () => {
	const {setPage} = usePageContext()

	React.useEffect(() => setPage(PAGE.SUIVI_AVANCEMENT), [])

	return (
		<AccessChecker access={getAccessCheckerRole(PROFILS.CHEF)}>
			<DialogProvider>
				<DetailPanelProvider>
					<ActionPanelProvider>
						<SuiviAvancementComponents/>
					</ActionPanelProvider>
				</DetailPanelProvider>
			</DialogProvider>
		</AccessChecker>
	)
}

export default SuiviAvancement
